import * as React from "react";
import {
  TextInput,
  Edit,
  useRecordContext,
  Title,
  ImageInput,
  ImageField,
  BooleanInput,
  FormDataConsumer,
  SelectInput,
  ReferenceArrayInput,
  AutocompleteArrayInput,
  DateTimeInput,
} from "react-admin";
import { SimpleForm } from "../common/SimpleForm";
import { validateRequired, validateVideoStartDate } from "../utils/Validations";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import { VIDEO_TYPES } from "../enums/VideoTypes";
import { RESTAURANT_TYPES } from "../enums/RestaurantTypes";
import { Box } from "@mui/material";

const VideoTitle = () => {
  const record = useRecordContext();
  return <Title title={`Video "${record?.name}"`} />;
};

const VideoEdit = () => (
  <Edit title={<VideoTitle />} mutationMode="pessimistic" redirect="list">
    <SimpleForm>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <>
            <TextInput
              label="Nombre"
              source="name"
              validate={validateRequired}
              fullWidth
            />
            <ImageInput
              source="thumbnail"
              label="Miniatura"
              accept={{
                "image/*": [],
              }}
              validate={validateRequired}
              maxSize={IMAGE_MAX_SIZE}
            >
              <ImageField source="src" title="Imagen" />
            </ImageInput>
            <FormDataConsumer>
              {({ formData, ...rest }) => {
                if (!formData.thumbnail.rawFile) {
                  return <ImageField source="thumbnail" {...rest} />;
                }
              }}
            </FormDataConsumer>
            <SelectInput
              label="Tipo"
              source="type"
              choices={[
                { id: VIDEO_TYPES.RESTAURANT, name: "Restaurante" },
                // { id: VIDEO_TYPES.PRODUCT, name: "Producto" },
              ]}
              validate={validateRequired}
              fullWidth
              readOnly
            />
            {formData?.type === VIDEO_TYPES.RESTAURANT && (
              <ReferenceArrayInput
                source="restaurants"
                reference="restaurants"
                perPage={100}
                filter={{
                  active: true,
                  type: RESTAURANT_TYPES.REGULAR,
                }}
              >
                <AutocompleteArrayInput
                  filterToQuery={(searchText) => ({
                    name: searchText,
                  })}
                  label="Restaurantes"
                  helperText="Puedes elegir más de un restaurante"
                  fullWidth
                  optionText="name"
                />
              </ReferenceArrayInput>
            )}
            <Box sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <DateTimeInput
                    source="startDate"
                    label="Fecha Inicio"
                    parse={(v) => v && new Date(v).toISOString()}
                    validate={validateVideoStartDate}
                    fullWidth
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <DateTimeInput
                    source="endDate"
                    label="Fecha Fin"
                    parse={(v) => v && new Date(v).toISOString()}
                    fullWidth
                  />
                </Box>
              </Box>
            </Box>
            <BooleanInput source="active" label="Activo" fullWidth />
          </>
        )}
      </FormDataConsumer>
    </SimpleForm>
  </Edit>
);

export default VideoEdit;
